import {ActionContext, ActionTree} from 'vuex';
import { ApiState } from './types';
import { RootState } from './../types';
import { MutationTypes } from './mutations';

export enum ActionTypes {
    SET_IS_INTENSIVE_USED_API = 'SET_IS_INTENSIVE_USED_API',
    INCREMENT_ON_GOING_REQUESTS = 'INCREMENT_ON_GOING_REQUESTS',
    DECREMENT_ON_GOING_REQUESTS = 'DECREMENT_ON_GOING_REQUESTS',
    SET_SERVER_HOST = 'SET_SERVER_HOST',
    SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL = 'SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL',
    SET_URL = 'SET_URL',
    SET_RESPONSE = 'SET_RESPONSE',
    UPDATE_DATA = 'UPDATE_DATA'
}

export type Actions = {
    [ActionTypes.SET_IS_INTENSIVE_USED_API]: (cxt: ActionContext<ApiState, RootState>, isIntensiveUsedApi: boolean) => void
    [ActionTypes.INCREMENT_ON_GOING_REQUESTS]: (cxt: ActionContext<ApiState, RootState>) => void
    [ActionTypes.DECREMENT_ON_GOING_REQUESTS]: (cxt: ActionContext<ApiState, RootState>) => void
    [ActionTypes.SET_SERVER_HOST]: (cxt: ActionContext<ApiState, RootState>, serverHost: string) => void
    [ActionTypes.SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL]: (ctx: ActionContext<ApiState, RootState>, serviceDownIntervalShortEval: number) => void,
    [ActionTypes.SET_URL]: (ctx: ActionContext<ApiState, RootState>, url: string) => void,
    [ActionTypes.SET_RESPONSE]: (ctx: ActionContext<ApiState, RootState>, response: Object) => void,
    [ActionTypes.UPDATE_DATA]: (ctx: ActionContext<ApiState, RootState>, data: Object) => void
}

export const actions: ActionTree<ApiState, RootState> = {
    [ActionTypes.SET_IS_INTENSIVE_USED_API]: ({ commit }, isIntensiveUsedApi) => commit(MutationTypes.SET_IS_INTENSIVE_USED_API, isIntensiveUsedApi),
    [ActionTypes.INCREMENT_ON_GOING_REQUESTS]: ({ commit }) => commit(MutationTypes.INCREMENT_ON_GOING_REQUESTS),
    [ActionTypes.DECREMENT_ON_GOING_REQUESTS]: ({ commit }) => commit(MutationTypes.DECREMENT_ON_GOING_REQUESTS),
    [ActionTypes.SET_SERVER_HOST]: ({ commit }, serverHost) => commit(MutationTypes.SET_SERVER_HOST, serverHost),
    [ActionTypes.SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL]: ({ commit }, serviceDownIntervalShortEval) => commit(MutationTypes.SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL, serviceDownIntervalShortEval),
    [ActionTypes.SET_URL]: ({ commit }, url) => commit(MutationTypes.SET_URL, url),
    [ActionTypes.SET_RESPONSE]: ({ commit }, response) => commit(MutationTypes.SET_RESPONSE, response),
    [ActionTypes.UPDATE_DATA]: ({ commit }, data) => commit(MutationTypes.UPDATE_DATA, data)
};